export const environment = {
  production: true,
  name: "staging",
  apiUrl: "https://stage-api.40p.co",
  socketUrl: "https://stage-api.40p.co"
};
